<div class="main-container">
    <div class="top-bar">
        <div class="top-bar-item">
            <p-selectButton [options]="languages" optionLabel="name" [(ngModel)]="selectedLanguage"
            (onChange)="updateTemplateList()"></p-selectButton>
            <p-button label="Add new template" routerLink="/management/create-lead-email-template"></p-button>
        </div>
    </div>
    <ng-container *ngIf="templates | async as data">
        <p-table selectionMode="single" [value]="data">
            <ng-template pTemplate="header">
                <tr>
                    <th [style]="{width: '80px'}">
                        ID
                    </th>
                    <th>
                        Name
                    </th>
                    <th [style]="{width: '90px'}">
                        Language
                    </th>
                    <th>
                        Body
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-template>
                <tr [pSelectableRow]="template">
                    <td>
                        {{template.id}}
                    </td>
                    <td>
                        <a routerLink="/management/edit-lead-email-template/{{template.id}}">
                            {{template.name}}
                        </a>
                    </td>
                    <td class="name-box">
                        {{template.language.name}}
                    </td>
                    <td>
                        <p *ngIf="template.body.length < 40">
                            {{template.body}}
                        </p>
                        <p *ngIf="template.body.length >= 40">
                            {{template.body.substring(0,30) + "..."}}
                        </p>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </ng-container>
</div>